import * as React from 'react'
import styled from 'styled-components'
import _ from 'lodash'

import { initialApartments } from 'floors-data/initialApartments'
import { FLOORS_DATA } from 'floors-data/floors-data'
// import UploadDataButton from './UploadDataButton'
import Floor2 from 'floor-plans/floor-2-UI'
import Floor3 from 'floor-plans/floor-3-UI'
import Floor4 from 'floor-plans/floor-4-UI'
import Floor5 from 'floor-plans/floor-5-UI'
import Floor6 from 'floor-plans/floor-6-UI'
import Floor7 from 'floor-plans/floor-7-UI'
import Floor8 from 'floor-plans/floor-8-UI'
import Floor9 from 'floor-plans/floor-9-UI'
import Floor10 from 'floor-plans/floor-10-UI'
import Floor11 from 'floor-plans/floor-11-UI'
import Floor12 from 'floor-plans/floor-12-UI'
import Floor13 from 'floor-plans/floor-13-UI'
import Floor14 from 'floor-plans/floor-14-UI'
import Floor15 from 'floor-plans/floor-15-UI'
import Floor16 from 'floor-plans/floor-16-UI'
import Floor17 from 'floor-plans/floor-17-UI'
import MinimizedNavigationPanel from './MinimizedNavigationPanel'

const floorComponents = {
  2: Floor2,
  3: Floor3,
  4: Floor4,
  5: Floor5,
  6: Floor6,
  7: Floor7,
  8: Floor8,
  9: Floor9,
  10: Floor10,
  11: Floor11,
  12: Floor12,
  13: Floor13,
  14: Floor14,
  15: Floor15,
  16: Floor16,
  17: Floor17,
}
const getUnlockFloors = floorsData => {
  const unlockFloors = floorsData.length
    ? floorsData
        .filter(({ isOpen }) => isOpen === true)
        .map(({ number }) => number)
        .sort()
    : []
  const sortedUnlockFloors = _.sortBy(unlockFloors)
  return sortedUnlockFloors
}

const getHighestFloor = floorsData => {
  const unlockFloors = getUnlockFloors(floorsData)
  const highestFloor = unlockFloors[unlockFloors.length - 1]
  return highestFloor
}

const getLowestFloor = floorsData => {
  const unlockFloors = getUnlockFloors(floorsData)
  const lowestFloor = unlockFloors[0]
  return lowestFloor
}

function getAvailableApartments(apartments, floorNumber) {
  const apartmentsOnThisFloor = apartments.filter(
    apartment => apartment.floor === floorNumber,
  )
  const availableApartments = apartmentsOnThisFloor.filter(
    apartment => apartment.status !== 'sold',
  )

  return availableApartments
}

const initialApartmentData = null

export default function NavigationPanel({
  krpano,
  hLookAt,
  apartments,
  floorsData,
  collapse,
  setCollapse,
}) {
  const highestFloor = getHighestFloor(floorsData)
  const lowestFloor = getLowestFloor(floorsData)
  const unlockFloors = floorsData.length
    ? floorsData
        .filter(({ isOpen }) => isOpen === true)
        .map(({ number }) => number)
        .sort()
    : []
  const sortedUnlockFloors = _.sortBy(unlockFloors)
  const [activeFloor, setActiveFloor] = React.useState(
    initialApartmentData?.floor || highestFloor,
  )
  const [activeApartment, setActiveApartment] = React.useState(
    initialApartmentData || initialApartments[highestFloor],
  )
  const [isSceneNameFuture, setIsSceneNameFuture] = React.useState(false)
  const [currentFace, setCurrentFace] = React.useState(
    initialApartmentData?.face || initialApartments[highestFloor]?.face,
  )
  const floors = Object.keys(FLOORS_DATA)

  const loadScene = React.useCallback(
    (sceneName, lookAt, activeFace) => {
      if (krpano) {
        const hlookat = krpano.get('view.hlookat')
        const vlookat = krpano.get('view.vlookat')
        const fov = krpano.get('view.fov')
        const distortion = krpano.get('view.distortion')

        krpano.call(
          `loadscene(${sceneName}, null, MERGE, BLEND(0.5, easeInCubic)); lookat(${lookAt});`,
        )

        if (currentFace === activeFace) {
          krpano.set('view.hlookat', hlookat)
          krpano.set('view.vlookat', vlookat)
          krpano.set('view.fov', fov)
          krpano.set('view.distortion', distortion)
        }
      }
    },
    [currentFace, krpano],
  )

  const changeView = React.useCallback(
    (floorNumber, aptNumber) => {
      const apartment = FLOORS_DATA[floorNumber].find(
        e => e.apartmentNumber === aptNumber,
      )
      const lookAt = apartment.lookAt
      const activeFace = apartment.face
      const sceneName = isSceneNameFuture
        ? apartment.sceneName_future
        : apartment.sceneName

      setActiveFloor(floorNumber)
      setActiveApartment(apartment)
      setCurrentFace(activeFace)
      loadScene(sceneName, lookAt, activeFace)
    },
    [isSceneNameFuture, loadScene],
  )

  const changeViewToAvailableApartmentOnly = React.useCallback(
    (floorNumber, aptNumber) => {
      const apartmentsOnThisFloor = apartments.filter(
        apartment => apartment.floor === floorNumber,
      )
      const availableApartments = apartmentsOnThisFloor.filter(
        apartment => apartment.status !== 'sold',
      )
      const chosenApartmentStatus = apartmentsOnThisFloor.find(
        apartment => apartment.number === aptNumber,
      )?.status
      const isSoldApartment = chosenApartmentStatus === 'sold' || false

      if (isSoldApartment) {
        if (!availableApartments.length && floorNumber === highestFloor) {
          const availableApartmentsOnPreviousFloor = getAvailableApartments(
            apartments,
            highestFloor - 1,
          )
          const sortedApartmentsByNumber = _.sortBy(
            availableApartmentsOnPreviousFloor,
            ['number'],
          )
          const goToApartment =
            sortedApartmentsByNumber[sortedApartmentsByNumber.length - 1].number

          changeView(highestFloor - 1, goToApartment)
        } else {
          const goToApartment = availableApartments[0].number
          changeView(floorNumber, goToApartment)
        }
      } else {
        changeView(floorNumber, aptNumber)
      }
    },
    [apartments, changeView, highestFloor],
  )

  const changeFloor = navCase => {
    const { apartmentNumber, relatedApartments, floor } = activeApartment
    const targetedFloor = changeActiveFloor(navCase) || floor
    const targetedApartmentNumber =
      relatedApartments[targetedFloor] || apartmentNumber
    // getRelatedApartment(relatedApartments, targetedFloor)
    changeViewToAvailableApartmentOnly(targetedFloor, targetedApartmentNumber)
  }

  const changeActiveFloor = navCase => {
    let targetedFloor

    if (
      navCase === 'up' &&
      sortedUnlockFloors.indexOf(activeFloor) < sortedUnlockFloors.length - 1
    ) {
      const nextIndex = sortedUnlockFloors.indexOf(activeFloor) + 1
      targetedFloor = sortedUnlockFloors[nextIndex]
      const availableApartments = getAvailableApartments(
        apartments,
        targetedFloor,
      )

      if (!availableApartments.length && targetedFloor === highestFloor) {
        setActiveFloor(activeFloor)
      } else if (!availableApartments.length) {
        setActiveFloor(targetedFloor + 1)
        targetedFloor = targetedFloor + 1
      } else {
        setActiveFloor(targetedFloor)
      }
    }
    if (navCase === 'down' && sortedUnlockFloors.indexOf(activeFloor) > 0) {
      const nextIndex = sortedUnlockFloors.indexOf(activeFloor) - 1
      targetedFloor = sortedUnlockFloors[nextIndex]
      const availableApartments = getAvailableApartments(
        apartments,
        targetedFloor,
      )

      if (!availableApartments.length && targetedFloor === lowestFloor) {
        setActiveFloor(activeFloor)
      } else if (!availableApartments.length) {
        setActiveFloor(targetedFloor - 1)
        targetedFloor = targetedFloor - 1
      } else {
        setActiveFloor(targetedFloor)
      }
    }
    return targetedFloor
  }

  const changeApartInCollapsible = navCase => {
    const apartments = Object.values(FLOORS_DATA[activeFloor]).map(
      e => e.apartmentNumber,
    )
    const { apartmentNumber } = activeApartment
    const apartmentIndex = apartments.indexOf(apartmentNumber)

    if (navCase === 'next') {
      const nextIndex =
        apartmentIndex === apartments.length - 1 ? 0 : apartmentIndex + 1
      changeViewToAvailableApartmentOnly(activeFloor, apartments[nextIndex])
    }
    if (navCase === 'previous') {
      const prevIndex =
        apartmentIndex === 0 ? apartments.length - 1 : apartmentIndex - 1
      changeViewToAvailableApartmentOnly(activeFloor, apartments[prevIndex])
    }
  }

  React.useEffect(() => {
    if (krpano) {
      changeViewToAvailableApartmentOnly(
        activeFloor,
        activeApartment.apartmentNumber,
      )
    }
  }, [
    activeApartment.apartmentNumber,
    activeFloor,
    changeViewToAvailableApartmentOnly,
    krpano,
  ])

  const toggleSceneNameFuture = () => setIsSceneNameFuture(!isSceneNameFuture)

  const floorPlanProps = {
    activeApartment,
    changeFloor,
    changeView,
    hLookAt,
    toggleSceneNameFuture,
    isSceneNameFuture,
    apartments,
    highestFloor: activeFloor === Number(floors[floors.length - 1]),
    lowestFloor: activeFloor === Number(floors[0]),
  }

  const renderUnlockFloorComponents = () => {
    return !!sortedUnlockFloors
      ? sortedUnlockFloors.map(floorNumber => {
          const UnlockFloor = floorComponents[floorNumber]

          return (
            <UnlockFloor
              key={floorNumber}
              floor={floorNumber}
              {...floorPlanProps}
            />
          )
        })
      : null
  }

  return collapse ? (
    <MinimizedNavigationPanel
      activeFloor={activeFloor}
      activeApartment={activeApartment}
      floors={floors}
      changeFloor={changeFloor}
      changeApartInCollapsible={changeApartInCollapsible}
      onClick={() => setCollapse(!collapse)}
    />
  ) : (
    <Wrapper collapse={Boolean(collapse) ? 'true' : undefined}>
      <SwitchComponents active={activeFloor}>
        {renderUnlockFloorComponents()}
      </SwitchComponents>
      <CloseButton onClick={() => setCollapse(!collapse)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path d="m254-159-94-95 225-226-225-226 94-96 226 226 226-226 94 96-225 226 225 226-94 95-226-226-226 226Z" />
        </svg>
      </CloseButton>
    </Wrapper>
  )
}

function SwitchComponents({ active, children }) {
  return !!children
    ? children.filter(child => child.props.floor === active)
    : null
}

const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: ${p => (p.collapse ? 'max-content' : '550px')};
  border-radius: 5px 5px 0 0;
  background-color: var(--brand-collapsible-color);
  z-index: 2;
  padding: ${p => (p.collapse ? '5px 10px' : 0)};

  @media (max-width: 575px) {
    right: 0;
    width: 100%;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    width: ${p => (p.collapse ? 'max-content' : '250px')};
    right: 0;
    bottom: 0;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (min--moz-device-pixel-ratio: 2) and (orientation: landscape) {
    width: ${p => (p.collapse ? 'max-content' : '250px')};
    right: 0;
    bottom: 0;
  }
`

const CloseButton = styled.button`
  position: absolute;
  top: -45px;
  right: 85px;
  background-color: var(--brand-primary-color);
  border: 0;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  width: 50px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: #ececec;
    width: 28px;
    height: 28px;
    margin-top: 5px;
    transition: fill 0.3s ease;
  }

  &:hover {
    cursor: pointer;

    svg {
      fill: var(--brand-green-color);
    }
  }

  @media (max-width: 575px) {
    top: -35px;
    right: 54px;
    width: 41px;
    height: 35px;

    svg {
      width: 20px;
      height: 20px;
      margin-top: 3px;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    top: -24px;
    right: 35px;
    width: 27px;
    height: 24px;

    svg {
      width: 15.5px;
      height: 15.5px;
      margin-top: 2px;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (min--moz-device-pixel-ratio: 2) and (orientation: landscape) {
    top: -24px;
    right: 35px;
    width: 27px;
    height: 24px;

    svg {
      width: 15.5px;
      height: 15.5px;
      margin-top: 3px;
    }
  }
`
